module.exports = __webpack_public_path__ + "static/variants-57993a402bc9a866785a0c240fe2852b.gif";